import { ReadonlyURLSearchParams } from 'next/navigation';

import {
  FilterConfigs,
  FiltersState,
  OptionFilterConfigs,
  OptionFilters,
} from '../../types/filters';

import { FILTER_VARIANTS } from '../../constants';

import { createRangeFromFiltersStateValue } from './createRangeFromFiltersStateValue';

const createFiltersStateFromOptions = (
  options: OptionFilters | undefined,
  searchParams: ReadonlyURLSearchParams | null
): FiltersState => {
  if (!Array.isArray(options)) {
    return {};
  }

  return options.reduce<FiltersState>((acc, option) => {
    return Object.assign(
      acc,
      createFiltersStateFromParams(option.filterConfigs, searchParams)
    );
  }, {});
};

export const createFiltersStateFromParams = (
  configs: FilterConfigs | OptionFilterConfigs,
  searchParams: ReadonlyURLSearchParams | null
) => {
  if (!searchParams) {
    return {};
  }

  return [...configs].reduce<FiltersState>((acc, config) => {
    const { filterVariant, filterKey } = config;

    if (filterVariant === FILTER_VARIANTS.SELECT) {
      return Object.assign(
        acc,
        createFiltersStateFromOptions(config.options, searchParams),
        {
          [filterKey]: searchParams.getAll(filterKey),
        }
      );
    }

    if (filterVariant === FILTER_VARIANTS.RANGE) {
      const [from, to] = createRangeFromFiltersStateValue(
        searchParams.get(filterKey.from),
        searchParams.get(filterKey.to)
      );

      return Object.assign(
        acc,
        createFiltersStateFromOptions(config.options, searchParams),
        {
          [filterKey.from]: from,
          [filterKey.to]: to,
        }
      );
    }

    if (filterVariant === FILTER_VARIANTS.INPUT) {
      return Object.assign(
        acc,
        createFiltersStateFromOptions(config.options, searchParams),
        {
          [filterKey]: searchParams.get(filterKey) || '',
        }
      );
    }

    if (filterVariant === FILTER_VARIANTS.OPTION) {
      return Object.assign(acc, {
        [filterKey]: searchParams.getAll(filterKey),
      });
    }

    return acc;
  }, {});
};
